import './projectTags.scss';
import * as React from 'react';
import { RoutePaths } from '../../routes';
import { Tag } from '../tag';
export const ProjectTags = ({ tags }) => (<div className="project-tags">
    {tags
    ?.filter((tag) => !!tag)
    ?.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1))
    .map((tag) => tag.name && <Tag content={tag.name} iconTicket={tag.icon?.[0].ticket} to={RoutePaths.projects.projectType(tag)} key={tag.name}/>)}
  </div>);
export default ProjectTags;
